<red-page-content>
  <form [formGroup]="referralForm" (ngSubmit)="onSubmit()">
    <div
      class="tw:relative tw:flex tw:min-h-full tw:w-full tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:px-4 tw:py-8"
    >
      <div class="tw:relative tw:h-40 tw:w-5/12">
        <img alt="Application Logo" class="tw:object-contain" ngSrc="/assets/logo.svg" fill priority />
      </div>
      <h1 class="tw:block tw:text-xl">
        <ion-text color="primary" class="tw:font-bold">Welcome</ion-text>
      </h1>
      <p class="md:tw:w-2/3 tw:w-full tw:text-center tw:text-sm">
        Enter the <b>Referral Code</b><br />
        provided by your title company
      </p>
      <div class="md:tw:w-2/3 tw:w-full">
        <ion-list [inset]="true" lines="full" class="no-last-line">
          <ion-item-group>
            <ion-item>
              <ion-input
                [redErrorMessage]="referralFormValidationErrors['code']"
                labelPlacement="stacked"
                [clearInput]="true"
                placeholder="e.g abcde123"
                inputmode="text"
                [required]="true"
                type="text"
                formControlName="code"
                [maxlength]="20"
              >
                <div slot="label">Referral Code:<ion-text color="danger">*</ion-text></div>
              </ion-input>
            </ion-item>
          </ion-item-group>
        </ion-list>
      </div>

      <div class="md:tw:w-2/3 tw:w-full tw:px-4">
        <ion-button color="primary" expand="block" type="submit" [disabled]="referralForm.invalid">Submit</ion-button>
      </div>
      <p class="tw:text-center tw:text-xs tw:font-thin">{{environment}} Version {{appVersion$ | async}}</p>
    </div>
  </form>
</red-page-content>
